import React from "react";
import { useLocation } from "react-router-dom";

const AdminClassicShell = ({ children }) => {
  const { pathname } = useLocation();
  const pageKey = pathname
    .replace(/^\/admin\/?/, "")
    .replace(/\/+/g, "-")
    .replace(/[^a-zA-Z0-9-_]/g, "")
    .toLowerCase() || "root";

  return (
    <div className="admin-classic-shell" data-admin-page={pageKey}>
      {children}
    </div>
  );
};

export default AdminClassicShell;
